import { Link } from "react-router-dom";
import { cn } from "../../../helpers/utils";

const DefaultLinkButton = ({ uri, label, className = "" }) => (
  <Link
    to={uri}
    className={cn(
      `flex items-center leading-[100%] underline text-[#DF2027] font-league-bold ${className}`
    )}
  >
    {label}
  </Link>
);

export default DefaultLinkButton;
